import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const WINDING_DIRECTION_URL = `${POSITION_PROPERTY_URL}/winding-directions`

const errors = createHandbookResponseErrors('направление навивки', 'направлений навивки')

export const WindingDirectionApi = createNewHandbookApi(WINDING_DIRECTION_URL, errors)
